<template>
  <div id="ranking_homepage">
    <van-row>
      <van-col span="24" class="ranking_homepage_top_bg">
        <van-col span="24">
          <van-nav-bar
              left-arrow
              placeholder
              safe-area-inset-top
              class="ranking_homepage_top_bg_bar"
              @click-left="onClickLeft"
          >
            <template #title>
              {{ $t('title.ranking_homepage') }}
            </template>
          </van-nav-bar>
        </van-col>
        <van-col span="22" offset="1" class="ranking_homepage_top_day">
          <van-tabs type="card" v-model="day_active" @click="onClickRankingDay">
            <van-tab :title="$t('column.day_list')" name="day"></van-tab>
            <van-tab :title="$t('column.week_list')" name="week"></van-tab>
            <van-tab :title="$t('column.Monthly_list')" name="month"></van-tab>
          </van-tabs>
        </van-col>
        <van-col span="22" offset="1" class="ranking_homepage_number_guang">
          <van-col span="7" class="ranking_homepage_number">
            <van-col span="22" offset="1" class="ranking_homepage_number_bg2 ranking_homepage_number_bg" @click="JumpUserinfo(list.length > 1 ? list[1] : 0)">
              <img src="../assets/img/rank/rank_homepage_avatar2.png" class="ranking_homepage_number_img2"/>
              <van-image
                  width="13vw"
                  height="13vw"
                  round
                  class="ranking_homepage_number_avatar"
                  fit="cover"
                  :src="list[1].head_image"
                  v-if="list.length > 1"
              />
              <van-col span="22" offset="1" class="ranking_homepage_number_name2"> {{ list.length > 1 ? list[1].nick_name : '' }} </van-col>

              <van-col span="22" offset="1" class="ranking_homepage_number_coin" v-if="list.length > 1"><img src="../assets/img/coin.png"/> {{ list.length > 1 ? list[1].ticket_k : '' }}</van-col>

              <van-col span="24" class="ranking_homepage_level" v-if="list.length > 1">
                <div class="ranking_homepage_sex_container">
                  <img :src="list[1].sex === 1 ? sex1 : sex2"/>
                  <span class="ranking_homepage_sex_number">{{ list[1].age }}</span>
                </div>
                <img :src="list[1].user_level_url"/>
              </van-col>
            </van-col>
          </van-col>
          <van-col span="10" class="ranking_homepage_number">
            <van-col span="18" offset="3" class="ranking_homepage_number_bg1 ranking_homepage_number_bg" @click="JumpUserinfo(list.length > 0 ? list[0] : 0)">
              <img src="../assets/img/rank/rank_homepage_avatar1.png" class="ranking_homepage_number_img"/>
              <van-image
                  width="13vw"
                  height="13vw"
                  round
                  class="ranking_homepage_number_avatar"
                  fit="cover"
                  :src="list[0].head_image"
                  v-if="list.length > 0"
              />
              <van-col span="22" offset="1" class="ranking_homepage_number_name1">{{ list.length > 0 ? list[0].nick_name : '' }} </van-col>

              <van-col span="22" offset="1" class="ranking_homepage_number_coin" v-if="list.length > 0"><img src="../assets/img/coin.png"/>  {{ list.length > 0 ? list[0].ticket_k : '' }} </van-col>
              <van-col span="24" class="ranking_homepage_level" v-if="list.length > 0">
                <div class="ranking_homepage_sex_container">
                  <img :src="list[0].sex === 1 ? sex1 : sex2"/>
                  <span class="ranking_homepage_sex_number">{{ list[0].age }}</span>
                </div>
                <img :src="list[0].user_level_url"/>
              </van-col>
            </van-col>
          </van-col>
          <van-col span="7" class="ranking_homepage_number">
            <van-col span="22" offset="1" class="ranking_homepage_number_bg3 ranking_homepage_number_bg" @click="JumpUserinfo(list.length > 2 ? list[2] : 0)">
              <img src="../assets/img/rank/rank_homepage_avatar3.png" class="ranking_homepage_number_img2"/>
              <van-image
                  width="13vw"
                  height="13vw"
                  round
                  class="ranking_homepage_number_avatar"
                  fit="cover"
                  :src="list[2].head_image"
                  v-if="list.length > 2"
              />
              <van-col span="22" offset="1" class="ranking_homepage_number_name3">{{ list.length > 2 ? list[2].nick_name : '' }} </van-col>

              <van-col span="22" offset="1" class="ranking_homepage_number_coin" v-if="list.length > 2"> <img src="../assets/img/coin.png"/>  {{ list.length > 2 ? list[2].ticket_k : '' }}  </van-col>
              <van-col span="24" class="ranking_homepage_level" v-if="list.length > 2">
                <div class="ranking_homepage_sex_container">
                  <img :src="list[2].sex === 1 ? sex1 : sex2"/>
                  <span class="ranking_homepage_sex_number">{{ list[2].age }}</span>
                </div>
                <img :src="list[2].user_level_url"/>
              </van-col>
            </van-col>
          </van-col>
        </van-col>

      </van-col>
      <van-col span="22" offset="1" class="ranking_homepage_list">
        <van-list>
          <van-cell v-for="(item,i) in list" :key="i" v-if="i > 2">
            <van-col span="24" class="ranking_homepage_list_item">
              <van-col span="3" class="ranking_homepage_list_item_number">{{ i + 1 }}</van-col>
              <van-col span="4" class="ranking_homepage_list_item_avatar">
                <van-image
                    width="10vw"
                    height="10vw"
                    round
                    :src="item.head_image"
                    fit="cover"
                    @click="JumpUserinfo(item)"
                />
                <div :id='"popular_svga"+item.user_id' class="ranking_homepage_list_item_avata_frame" @click="JumpUserinfo(item)" v-if="item.avatar_frame_url"></div>
              </van-col>
              <van-col span="9">
                <van-col span="24" class="ranking_homepage_list_item_user_name">{{ item.nick_name }}</van-col>
                <van-col span="24" class="ranking_homepage_list_item_user_level">
                  <div class="ranking_homepage_sex_container">
                    <img :src="item.sex === 1 ? sex1 : sex2"/>
                    <span class="ranking_homepage_sex_number">{{ item.age }}</span>
                  </div>
                  <img :src="item.user_level_url" class="ranking_homepage_list_item_user_level_name"/>
                </van-col>
              </van-col>
              <van-col span="8" class="ranking_homepage_list_item_coin"><img src="../assets/img/coin.png"/> {{ item.ticket_k }}</van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-col span="24" class="ranking_homepage_bottom">
        <van-col span="2" offset="1" class="ranking_homepage_bottom_number">{{ user.user_rank ? user.user_rank : '' }}</van-col>
        <van-col span="4" class="ranking_homepage_list_item_avatar">
          <van-image
              width="10vw"
              height="10vw"
              round
              :src="user.head_image"
              fit="cover"
              @click="JumpUserinfo(user)"
          />
          <div id='popular_svga_self' class="ranking_homepage_list_item_avata_frame" @click="JumpUserinfo(user)" v-if="user.avatar_frame_url"></div>
        </van-col>
        <van-col span="9" class="ranking_homepage_bottom_name">
          {{ user.nick_name }}
        </van-col>
        <van-col span="7" class="ranking_homepage_bottom_coin"><img src="../assets/img/coin.png"/> {{ user.ticket_k }}</van-col>
      </van-col>
      <van-overlay :show="overlayShow" z-index="3">
        <van-loading type="spinner" class="loading_overlay"/>
      </van-overlay>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";
import SVGA from "svgaplayerweb";

export default {
  data() {
    return {
      day_active: 'day',
      list: [],
      overlayShow: false,
      finished: false,
      sex1: require('../assets/img/sex1-1.png'),
      sex2: require('../assets/img/sex2-1.png'),
      user:[]
    }
  },
  created() {
    this.convert()
  },
  methods: {
    onClickRankingDay(name, title) {
      this.day_active = name
      this.finished = false;
      this.page = 1
      this.list = []
      this.convert()
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    JumpUserinfo(item) {
      console.log(item)
      if(item.id && item.is_noble_ranking_stealth === 0){
        // 拦截跳转用户主页面
        window.location.href="live://live?action=JumpUser&id=" + item.id
      }
    },
    SVGA() {
      this.$nextTick(()=>{
        this.list.map((v,i)=>{
          if (v.avatar_frame_url && i > 2) {
            //这里动态给ID，列表
            var player = new SVGA.Player('#popular_svga'+v.user_id);
            var parser = new SVGA.Parser('#popular_svga'+v.user_id);
            //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
            console.log('svga======')
            console.log(v.avatar_frame_url)
            parser.load(v.avatar_frame_url, function(videoItem) {
              player.setVideoItem(videoItem);
              player.startAnimation();
            })
          }
        })
        if (this.user.avatar_frame_url) {
          //这里动态给ID，列表
          var player1 = new SVGA.Player('#popular_svga_self');
          var parser1 = new SVGA.Parser('#popular_svga_self');
          //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
          console.log('svga======')
          parser1.load(this.user.avatar_frame_url, function(videoItem) {
            player1.setVideoItem(videoItem);
            player1.startAnimation();
          })
        }
      })
    },
    convert() {
      this.overlayShow = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=video&act=cont", {
        params : {
          token: token,
          rank_type: this.day_active,
          user_id: this.$route.query.host_id
        }
      }).then(res =>{
        this.overlayShow = false
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.list = []
        for(let i = 0; i< res.data.list.length; i ++) {
          res.data.list[i]['user_level_url'] =  require('../assets/img/rank_'+res.data.list[i].user_level+'.png')
          this.list.push(res.data.list[i])
        }
        this.user = res.data.user
        this.SVGA()
        this.finished = true
      })
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ranking_homepage.vue